"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_2 = require("@osmosys/react");
const hooks_1 = require("../hooks");
const reactstrap_1 = require("reactstrap");
const react_loops_1 = require("react-loops");
const constants_1 = require("../constants");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
exports.FeatureDemoPersonasList = () => {
    const { state: { persona: activePersona }, dispatch, } = hooks_1.useFeatureDemoContext();
    return (react_1.default.createElement(react_2.OsmosysDiv, { className: "text-center" },
        react_1.default.createElement(reactstrap_1.Nav, { pills: true, className: "d-flex justify-content-center my-2" },
            react_1.default.createElement(reactstrap_1.NavItem, { active: activePersona === undefined },
                react_1.default.createElement(reactstrap_1.NavLink, { active: activePersona === undefined, href: "#", onClick: e => {
                        e.preventDefault();
                        dispatch({
                            payload: {
                                persona: undefined,
                            },
                            type: 'update',
                        });
                    } },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faInfinity, className: "mr-2" }),
                    react_1.default.createElement(react_2.OsmosysChangeCase, { type: "titleCase" }, "All"))),
            react_1.default.createElement(react_loops_1.For, { in: constants_1.FEATURE_CONFIG.personas }, (config, { key: persona }) => {
                return (react_1.default.createElement(reactstrap_1.NavItem, { active: activePersona === persona },
                    react_1.default.createElement(reactstrap_1.NavLink, { active: activePersona === persona, href: "#", onClick: e => {
                            e.preventDefault();
                            dispatch({
                                payload: {
                                    persona,
                                },
                                type: 'update',
                            });
                        } },
                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faUserAstronaut, className: "mr-2" }),
                        react_1.default.createElement(react_2.OsmosysChangeCase, { type: "titleCase" }, persona))));
            }))));
};
//# sourceMappingURL=index.js.map